import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class IcEvents {
	private fatalReducerError = new Subject<void>();
	public fatalReducerError$ = this.fatalReducerError.asObservable();

	notifyFatalReducerError() {
		this.fatalReducerError.next();
	}
}
